import script from "./SidebarItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarItem.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarItem.vue?vue&type=style&index=0&id=4b51242e&lang=scss"

const __exports__ = script;

export default __exports__